import React, { useContext, useEffect, useRef, useState } from 'react'
import { SnackBarContext } from 'src/App'
import useFileUpload from 'react-use-file-upload'
import axios from 'axios'
import authHeader from 'src/services/auth-header'
import { useParams } from 'react-router-dom'

const SlackUploadAvatar = ({ onUploadDone = () => {}, defaultImage }) => {
  const [fileUploading, setFileUploading] = useState(false)
  const [img, setImg] = useState(defaultImage)

  const { setSuccessMessage, setErrorMessage } = useContext(SnackBarContext)
  const { files, setFiles, clearAllFiles } = useFileUpload()
  const inputRef = useRef()
  const { id } = useParams()
  const campaignId = id

  useEffect(() => {
    if (files.length) {
      const formData = new FormData()
      formData.append('file', files[0])
      setErrorMessage(null)

      const allowedExtensions = ['.jpg', '.jpeg', '.png']
      const fileExtension = files[0].name.substring(files[0].name.lastIndexOf('.')).toLowerCase()

      if (!allowedExtensions.includes(fileExtension)) {
        setErrorMessage('Only .jpg or .png extentions allowed')
        clearAllFiles()
        setFileUploading(false)
        return
      }

      try {
        setFileUploading(true)
        axios
          .post(
            window._env_.REACT_APP_API_HOST + '/v2/simulation-campaigns/' + campaignId + '/steps/upload-avatar',
            formData,
            {
              'content-type': 'multipart/form-data',
              headers: authHeader()
              // responseType: 'blob'
            }
          )
          .then(resp => {
            setFileUploading(false)
            clearAllFiles()
            setImg(resp.data.path)
            onUploadDone(resp.data.path)
            // location.reload()

            if (resp.status == 200) {
              setSuccessMessage('Upload done')
            }
          })
          .catch(async error => {
            clearAllFiles()
            const text = await error?.response?.data.text()
            const errorData = JSON.parse(text)
            setErrorMessage(errorData.description || 'Something went wrong')
            setFileUploading(false)
          })
      } catch (error) {
        console.error('Failed to submit files.')
      }
    }
  }, [files])

  return (
    <div className='row row-center select-image'>
      <div
        onClick={() => inputRef.current.click()}
        style={{
          width: '50px',
          height: '50px',
          display: 'flex',
          borderRadius: img ? '0px' : '25px',
          overflow: 'hidden',
          backgroundColor: img ? 'transparent' : 'rgb(97, 35, 255)',
          alignItems: 'center',
          justifyContent: 'center',
          marginRight: '16px',
          flexShrink: 0,
          cursor: 'pointer'
        }}
      >
        {img ? (
          <img style={{ maxHeight: '100%', maxWidth: '100%' }} src={img} alt='profile-photo' />
        ) : (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: '#5F5F68',
              cursor: 'pointer'
            }}
          >
            <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
              <path
                d='M19.6515 19.4054C20.2043 19.2902 20.5336 18.7117 20.2589 18.2183C19.6533 17.1307 18.6993 16.1749 17.4788 15.4465C15.907 14.5085 13.9812 14 12 14C10.0188 14 8.09292 14.5085 6.52112 15.4465C5.30069 16.1749 4.34666 17.1307 3.74108 18.2183C3.46638 18.7117 3.79562 19.2902 4.34843 19.4054C9.39524 20.4572 14.6047 20.4572 19.6515 19.4054Z'
                fill='#fff'
              />
              <circle cx='12' cy='8' r='5' fill='#fff' />
            </svg>
          </div>
        )}
      </div>
      <input
        ref={inputRef}
        disabled={fileUploading}
        type='file'
        accept='.png, .jpg, .jpeg'
        style={{ display: 'none' }}
        onChange={e => {
          setFiles(e, 'a')
          inputRef.current.value = null
        }}
      />
      <div className='column' style={{ marginRight: 80 }}>
        <p
          className='select-image-title'
          style={{ fontSize: 14, fontWeight: 700, cursor: 'pointer' }}
          onClick={() => inputRef.current.click()}
        >
          User avatar
        </p>
        <p style={{ color: '#76767D', fontSize: 14, cursor: 'pointer' }} onClick={() => inputRef.current.click()}>
          Click to upload user avatar
        </p>
      </div>
    </div>
  )
}

export default SlackUploadAvatar
